import { render, staticRenderFns } from "./statusColumn.vue?vue&type=template&id=0f6cbb4c&scoped=true&"
import script from "./statusColumn.vue?vue&type=script&lang=js&"
export * from "./statusColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6cbb4c",
  null
  
)

export default component.exports